import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" fill="none" viewBox="0 0 19 18">
            <path
                fill="#00214D"
                d="M16.964 2v2h-3.992V2h3.992zM6.983 2v6H2.99V2h3.993zm9.981 8v6h-3.992v-6h3.992zm-9.981 4v2H2.99v-2h3.993zM18.96 0h-7.985v6h7.985V0zM8.98 0H.993v10H8.98V0zm9.98 8h-7.985v10h7.985V8zm-9.98 4H.993v6H8.98v-6z"
            ></path>
        </svg>
    );
}

export default Icon;
